
import React from 'react';
import { FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore } from 'application/facility-order-new-flow-insurance/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore')
@observer
class FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal;
